import { Box, createStyles, makeStyles, Slider, Theme, useTheme } from '@material-ui/core';
import * as React from 'react';
import { Dispatch, SetStateAction } from 'react';
import { AnalysisFilterState } from '../../../pages/AnalysisPage/Filter/analysisFilterState';

export interface HBLtSliderProps {
  analysisFilterState: AnalysisFilterState;
  setAnalysisFilterState: Dispatch<SetStateAction<AnalysisFilterState>>;
}

const useClasses = makeStyles((theme: Theme) =>
  createStyles({
    valueLabel: {
      top: -18,
      '& *': {
        background: 'transparent',
        color: '#000',
      },
    },
    markLabel: {
      transform: 'translateX(50%)',
    },
    rail: {
      height: 2,
      color: theme.palette.primary.main,
      opacity: 1,
    },
  })
);
let beforeChange: number[] = [null, null];
const HBLtSlider: React.FC<HBLtSliderProps> = ({ analysisFilterState, setAnalysisFilterState }) => {
  const marks = [
    {
      value: 1,
      label: 'Head',
    },
    {
      value: analysisFilterState?.hBLtValues[0],
      label: 'Body',
    },
    {
      value: analysisFilterState?.hBLtValues[1],
      label: 'Long-tail',
    },
  ];
  const handleChange = (event: any, newValue: number[]) => {
    beforeChange = [...analysisFilterState?.hBLtValues];

    if (
      newValue[0] == beforeChange[1] ||
      newValue[0] < 2 ||
      newValue[1] <= beforeChange[0] ||
      newValue[1] < 3
    ) {
      return;
    }

    setAnalysisFilterState((prev) => ({
      ...prev,
      hBLtValues: newValue,
    }));
  };

  const handleChangeCommitted = () => {
    beforeChange = null;
  };
  const theme = useTheme();
  const classes = useClasses(theme);
  return (
    <>
      <Box pt={3.25} m={'auto'} width={'240px'}>
        <Slider
          min={1}
          max={4}
          marks={marks}
          value={analysisFilterState?.hBLtValues}
          track={false}
          onChange={handleChange}
          onChangeCommitted={handleChangeCommitted}
          valueLabelDisplay="on"
          classes={{
            valueLabel: classes.valueLabel,
            markLabel: classes.markLabel,
            rail: classes.rail,
          }}
        />
      </Box>
    </>
  );
};

export default HBLtSlider;
